import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

const FlexCourseCard = memo(({ item, compact, hideLink, gridLayout }) => {
  const courseNumber = item.course_number;
  const titleBlock = (
    <>
      {item.type_of_course && (
        <h6 className="cards__subtitle">{vocabTitle(item.type_of_course)}</h6>
      )}
      <h4 className="cards__title">{item.title ? item.title : item.id}</h4>
    </>
  );

  return (
    <div
      className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
    >
      {!compact && (
        <CardImage
          item={item}
          fallback={'/course_default_image.png'}
          gridLayout={gridLayout}
          href={hideLink ? undefined : item['@id']}
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          titleBlock
        ) : (
          <UniversalLink href={item['@id']}>{titleBlock}</UniversalLink>
        )}
        {courseNumber && (
          <p className="cards__info">
            <span className="cards__info-label">Course number: </span>
            {courseNumber}
          </p>
        )}
      </div>
    </div>
  );
});

FlexCourseCard.displayName = 'FlexCourseCard';

FlexCourseCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    '@type': PropTypes.string,
    title: PropTypes.string,
    id: PropTypes.string,
    type_of_course: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    course_number: PropTypes.string,
    image_caption: PropTypes.string,
    image_scales: PropTypes.object,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexCourseCard;
